import { User } from '../types/auth';

export const ADMIN_DEPARTMENT_PARAM = 'admin_department';

export const isAdminUser = (user?: User | null): boolean =>
  Boolean(user?.is_superuser || user?.role_code === 'ADMIN');

export const getAdminDepartmentIdFromSearch = (search: string): number | null => {
  const value = new URLSearchParams(search).get(ADMIN_DEPARTMENT_PARAM);
  if (!value) return null;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const withAdminDepartment = (path: string, departmentId?: number | null): string =>
  departmentId ? `${path}?${ADMIN_DEPARTMENT_PARAM}=${departmentId}` : path;

export const withAdminDepartmentParam = (
  params: Record<string, any> = {},
  departmentId?: number | null,
): Record<string, any> => {
  if (!departmentId) return params;
  return { ...params, [ADMIN_DEPARTMENT_PARAM]: departmentId };
};
